"use strict";

import * as angular from "angular"


angular.module("tabsint.plugin-modules", []);
